var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10a4 4 0 10-3.794-2.73L9.907 9.252a4 4 0 10.002 5.493l3.298 1.98a4 4 0 10.883-1.47l-3.298-1.98a3.993 3.993 0 00-.001-2.555l3.295-1.98A3.989 3.989 0 0017 10zm2.8 8a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0zm0-12a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0zm-10 6a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0z"
  })));
}

export default SvgShare;